import Navigation from "$/lib/components/molecules/Navigation/Navigation";
import { useIsMobile } from "$/lib/hooks/useIsMobile";
import { ROUTES } from "$/lib/utils/constants/routes.constants";

import { useProfileProvider } from "../providers/ProfileProvider";
import ProfileCompletionStatus from "./ProfileCompletionStatus";

const ProfileNavigation = () => {
  const { profileCompletion, setLastVisitedTab } = useProfileProvider();
  const isMobile = useIsMobile();

  return (
    <Navigation
      className="flex-1 flex-col gap-4 screen850:flex-row screen850:gap-0"
      links={[
        {
          label: "Général",
          route: ROUTES.PROFILE_GENERAL,
          onClick: () => setLastVisitedTab("general"),
          badgeCount: profileCompletion?.generalInfoMissingYears.length,
        },
        {
          label: isMobile ? "Social" : "Profil social",
          route: ROUTES.PROFILE_SOCIALSECURITY,
          onClick: () => setLastVisitedTab("socialSecurity"),
          badgeCount: profileCompletion?.socialInfoMissingYears.length,
        },
        {
          label: isMobile ? "Fiscal" : "Profil fiscal",
          route: ROUTES.PROFILE_FISCAL,
          onClick: () => setLastVisitedTab("fiscal"),
          badgeCount: profileCompletion?.fiscalInfoMissingYears.length,
        },
        {
          label: isMobile ? "Comptable" : "Profil comptable",
          route: ROUTES.ACCOUNTING_DATA,
          onClick: () => setLastVisitedTab("accounting"),
          badgeCount: profileCompletion?.accountingDataMissingYears.length,
        },
      ]}
    >
      <div className="relative order-first flex w-full justify-between gap-4 px-6 screen850:order-none screen850:w-auto screen850:gap-12 screen850:px-0 screen850:pl-12">
        <div className="my-0.5 hidden w-px bg-border screen850:block"></div>
        <ProfileCompletionStatus containerClassName="w-full gap-6 justify-center screen850:w-auto screen850:justify-normal" />
      </div>
    </Navigation>
  );
};

export default ProfileNavigation;
